/**
 * Les cinq mots de l'écran, définis en une ligne chacun (C24 SP3, décisions 11
 * à 13) — « Un mot pour le code, un mot pour l'écran » (docs/VOCABULAIRE_ECRAN.md).
 *
 * UN seul texte : l'onglet « Les mots » de l'aide des Notes (`MotsGuide`), le
 * pied de « Comment ça marche » sur le téléphone et les écrans vides de
 * Concepts et de Vocabulaires (`entreeTableLabels.videAide`,
 * `vocabulaireLabels.section.aucunAide`) lisent ces lignes ; rien n'est recopié.
 * Dans l'ordre où on les rencontre ; cinq mots, pas douze (« piste », « face à
 * face », « correspondance », « plateau » s'expliquent là où on les rencontre).
 * Jamais « glossaire » (mot réservé par VOCABULAIRE_ECRAN.md § 2).
 */
export interface MotDeLEcran {
  mot: string;
  /** Une phrase, un seul point final. */
  ligne: string;
  /** Où on le fait : le bouton ou la section, tels qu'écrits à l'écran. */
  ou: string;
}

export const MOTS_DE_L_ECRAN = {
  note: {
    mot: 'Note',
    ligne: 'Ce que vous écrivez : quelques lignes à vous, ou un passage gardé d’un document.',
    ou: '« Écrire une note », dans les Notes.',
  },
  citation: {
    mot: 'Citation',
    ligne: 'Une note qui garde un passage avec sa page.',
    ou: '« Citer » dans le lecteur, « Dicter une citation » sur le téléphone.',
  },
  concept: {
    mot: 'Concept',
    ligne: 'Un concept est une définition que vous écrivez ; chaque passage rattaché vient la préciser.',
    ou: '« Relier à un concept… » sur un passage, ou « Nouveau concept » dans les Concepts.',
  },
  dossier: {
    mot: 'Dossier',
    ligne: 'Là où se rangent vos notes et vos documents ; « Général » est celui de départ.',
    ou: '« Nouveau dossier », dans les Dossiers.',
  },
  vocabulaire: {
    mot: 'Vocabulaire',
    ligne: 'Un vocabulaire réunit les concepts d’un domaine : un cours, un auteur, un projet.',
    ou: '« Créer un vocabulaire », dans les Vocabulaires ; se partage avec vos contacts.',
  },
} as const satisfies Record<string, MotDeLEcran>;

/** Les cinq, dans l'ordre où on les rencontre. */
export const MOTS_DANS_L_ORDRE: ReadonlyArray<MotDeLEcran> = [
  MOTS_DE_L_ECRAN.note, MOTS_DE_L_ECRAN.citation, MOTS_DE_L_ECRAN.concept, MOTS_DE_L_ECRAN.dossier, MOTS_DE_L_ECRAN.vocabulaire,
];

export const TITRE_LES_MOTS = 'Les mots';
